<template>
  <div class="top-right-cmp">
    <dv-charts :option="option" style="width: 100%; height: 500px" />
  </div>
</template>

<script>
import { changeDefaultConfig } from "@jiaminghi/charts";
export default {
  name: "TopRightCmp",
  mounted() {
    changeDefaultConfig("yAxis", ["#2CF0C7", "#5BB0FF"]);
  },
  data() {
    return {
      option: {
        title: {
          show: false,
        },
        legend: {
          top: 40,
          textStyle: {
            fill: "#fff",
          },
          data: [
            { name: "系列A", color: "#2CF0C7" },
            { name: "系列B", color: "#5BB0FF" },
          ],
        },
        xAxis: {
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          axisLabel: {
            style: {
              fontSize: 20,
            },
          },
        },
        yAxis: {
          data: "value",
          axisLabel: {
            style: {
              fontSize: 20,
            },
          },
        },
        series: [
          {
            name: "系列A",
            data: [1200, 2230, 1900, 2100, 3500, 4200, 3985],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(5, 246, 255, 0.75)", "rgba(5, 246, 255, 0.08)"],
            },
          },
          {
            name: "系列B",
            data: [120, 230, 900, 200, 350, 420, 398],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(5, 246, 255, 0.75)", "rgba(5, 246, 255, 0.08)"],
            },
          },
        ],
      },
    };
  },
};
</script>

<style>
.top-right-cmp {
  position: relative;
  padding: 0 50px;
  box-sizing: border-box;
}
.chart-name {
  position: absolute;
  right: 70px;
  text-align: right;
  font-size: 20px;
  top: 10px;
}
</style>
